/**
 * @prettier
 * @flow
 */
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from 'src/utils/translate/translate';

export function FormEmailField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    const maxLength = 100;

    return (
        <Controller
            as={TextField}
            name={`${name}.email`}
            label={label}
            placeholder={translate('Email')}
            // helperText={errors[name]?.['email']?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('Email is required'),
                },
                maxLength: {
                    value: maxLength,
                    message: translate('Must be at most @number characters', { number: maxLength }),
                },
                pattern: {
                    value: /(?:(^\S+@\S+\.\S+$)|(^\s*$))/,
                    message: translate('Invalid email'),
                },
            }}
            error={!!errors[name]?.['email']}
            InputProps={{
                ...InputProps,
                endAdornment: (
                    <InputAdornment position='end'>
                        <AlternateEmailIcon color='action' />
                    </InputAdornment>
                ),
            }}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            value={value}
            onChange={onChange}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
            '&:hover fieldset': {
                // borderBottomColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderBottomColor: 'white',
            },
        },
    },
}));

export type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        email?: boolean,
        min?: number | { message: string, value: number },
        max?: number | { message: string, value: number },
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
